export const modalTypes = {
  SUCCESS: 1,
  STOCKSUCCESS: 2,
  UNAUTHORISED: 3,
  ERROR: 4
}